import { timeScalarToPlainString, type TimeScalar } from '../graphqlScalars';

/**
 * Epoch milliseconds for a GraphQL `Time` instant read as {@link TimeScalar}.
 * Invalid wire values yield `NaN`.
 */
export const timeScalarToEpochMs = (value: TimeScalar): number => {
  const ms = new Date(timeScalarToPlainString(value)).getTime();

  return Number.isFinite(ms) ? ms : Number.NaN;
};

/**
 * True when the instant is strictly after {@link Date.now()} on the current runtime clock.
 * Instant-only semantics (no locale formatting).
 */
export const isTimeScalarInFuture = (
  value: TimeScalar | null | undefined,
): boolean => {
  if (value == null) return false;

  const ms = timeScalarToEpochMs(value);

  return Number.isFinite(ms) && ms > Date.now();
};

/**
 * Same as {@link timeScalarToEpochMs} but treats nullish and `''` as `NaN` for optional GraphQL fields.
 */
export const timeScalarOrEmptyToEpochMs = (
  value: TimeScalar | '' | null | undefined,
): number => {
  if (value == null || value === '') return Number.NaN;

  return timeScalarToEpochMs(value);
};
